import { initializeApp } from "firebase/app";
import {
  browserSessionPersistence,
  initializeAuth,
  inMemoryPersistence,
} from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import firebaseKeys from "../keys/firebaseKeys.ts";
import { firestoreTransportSettings } from "./core/utils/firestoreTransport.ts";

const env = import.meta.env.VITE_ENV ?? "development";
export const firebaseOptions = firebaseKeys[env];

const app = initializeApp(firebaseOptions);
// Tab-only session: no popupRedirectResolver, so mobile browsers do not preload the auth-domain iframe.
export const auth = initializeAuth(app, {
  persistence: [browserSessionPersistence, inMemoryPersistence],
});
export const functions = getFunctions(app, "europe-west1");
export const storage = getStorage(app);
export const db = initializeFirestore(app, firestoreTransportSettings());
